import Link from 'next/link'

import styles from './PageItem.module.scss'

export type PageItemProps = {
	link: string
	title: string
	targetBlank?: boolean
}

export const PageItem = ({ link, title, targetBlank }: PageItemProps): JSX.Element => (
	<li className={styles.pageItem}>
		<Link
			href={link}
			prefetch={false}
			className={styles.link}
			target={targetBlank ? `_blank` : `_self`}
			rel={targetBlank ? `noreferrer` : undefined}>
			<span>{title}</span>
		</Link>
	</li>
)
